module.exports = __webpack_public_path__ + "static/media/Mobile-Banner-Doc-Upload.b2ec717f.jpg";